import UniqueId from '../../uid/UniqueId';
import UUIDService from '../../uid/UUIDService';
import DatasetTreeNode from '../dataset-tree/logical/DatasetTreeNode';
import DatasetTreeNodeVisitor from '../dataset-tree/logical/DatasetTreeNodeVisitor';
import DisplayModeDatasetTreeNode from '../dataset-tree/logical/DisplayModeDatasetTreeNode';
import DatasetViewModel from '../view-model/DatasetViewModel';

import ViewModelCompositorDatasetVisitorDelegate from './ViewModelCompositorDatasetVisitorDelegate';

/**
 * {@link DatasetTreeNode} tree visitor that manages the serialization of
 * logical dataset tree nodes into {@link DatasetViewModel} objects.
 */
class ViewModelCompositorDatasetVisitor implements DatasetTreeNodeVisitor {
  public datasetViewModel: DatasetViewModel | null = null;

  constructor(private delegate: ViewModelCompositorDatasetVisitorDelegate) {}

  /**
   * Returns a serialized {@link DatasetViewModel} object.
   */
  public getConstructedViewModel(): DatasetViewModel {
    if (!this.datasetViewModel) {
      throw new Error('Not constructed yet');
    }

    return this.datasetViewModel;
  }

  public visitDisplayModeDataset(node: DisplayModeDatasetTreeNode): void {
    const viewModel: DatasetViewModel = {
      id: new UUIDService().generateId(),
      name: node.getDatasetName(),
      parent: null,
      title: this.delegate.getDatasetTitle(node),
    };

    const parentNode = node.getParent();

    if (parentNode) {
      viewModel.parent = this.getOrConstructParentId(parentNode);
    }

    this.saveConstructedViewModel(node, viewModel);
  }

  private saveConstructedViewModel(
    node: DatasetTreeNode,
    viewModel: DatasetViewModel
  ) {
    this.datasetViewModel = viewModel;
    this.delegate.addDatasetViewModel(node, viewModel);
  }

  private getOrConstructParentId(parentNode: DatasetTreeNode): UniqueId {
    const parentId = this.delegate.getConstructedDatasetViewModelId(parentNode);

    if (parentId) {
      return parentId;
    }

    const parentVisitor = new ViewModelCompositorDatasetVisitor(this.delegate);

    parentNode.acceptVisitor(parentVisitor);

    return parentVisitor.getConstructedViewModel().id;
  }
}

export default ViewModelCompositorDatasetVisitor;
